import { normalizeChartingMutationResult } from '@/features/charting-next/adapters/chartingPreferenceAdapters';
import { get, postForm } from '@/features/charting-next/api/chartingRepositoryClient';
import { buildChartingMetricPreferencePayload, normalizeChartingMetricPreferences } from '@/features/charting-next/models/chartingMetricPreferences';

export async function fetchChartingMetricPreferences() {
    const stockPreferences = await get('/api/v1/stock-finder/metric-preferences');

    return normalizeChartingMetricPreferences({
        stockPreferences
    });
}

export async function updateChartingMetricPreferences(activeFields = []) {
    const payload = await postForm('/api/v1/update-preferences', {
        preferences: JSON.stringify(buildChartingMetricPreferencePayload(activeFields))
    });

    return normalizeChartingMutationResult(payload, 'Las metricas del graficador se han actualizado.');
}
